<template>
  <div class="delete-account">
    <div v-show="status != 'none'">
      <div class="step-1" v-if="step === 1">
        <div class="title">{{ $t('1') }}</div>
        <div class="delete-flex delete-head">
          <div class="delete-name">
            <img src="/static/img/dashboard/avatar_2x.png" alt="header img" />
            <div class="vip" :class="[isDueTo ?'yes': 'no' ]"></div>
            <div class="delete-name-text">{{user.nickname}}</div>
          </div>
          <div
            v-if="user.max_device_count"
            class="delete-date-text"
            :class="[isDueTo ?'yes': 'no' ]"
            v-html="isUserData ? (isDueTo ?$t('3') :$t('2')) : '&nbsp;'"
          ></div>
        </div>
        <div class="delete-flex">
          <div>{{ $t('4') }}</div>
          <div v-if="currentLang === 'en'">{{ user.max_device_count }}{{ user.max_device_count > 1 ? $t('5') :$t('one_5') }}</div>
          <div v-else>{{ user.max_device_count }}{{ $t('5') }}</div>
        </div>
        <div class="delete-flex delete-date">
          <div>{{ $t('6') }}</div>
          <div>{{ isUserData ? date : '-'}}</div>
        </div>
        <div class="delete-btn" :class="{'disabled': !isUserData}" @click="handClick(2)">{{ $t('7') }}</div>
      </div>
      <div class="step-2" v-if="step === 2">
        <div class="title">{{ $t('8') }}</div>
        <input class="delete-input" type="password" maxlength="50" :placeholder="$t('9')" v-model="pwd" />
        <div v-show="!loading" class="delete-btn" :class="{'disabled': !isUserData || pwd.length == 0}" @click="handClick(3)">{{$t('10')}}</div>
      </div>
      <div class="step-3" v-if="step === 3">
        <div class="title">{{$t('1')}}</div>
        <div class="delete-status">{{$t('11')}}</div>
        <div class="delete-status-msg">{{$t('12')}}</div>
        <div class="delete-btn" v-show="!loading" :class="{'disabled': disabled }" @click="handClick('cancel')">{{$t('13')}}</div>
      </div>
      <div class="step-3" v-if="step === 4">
        <div class="title">{{$t('1')}}</div>
        <div class="delete-status">{{$t('14')}}</div>
        <div class="delete-status-msg">{{$t('15')}}</div>
        <div class="delete-btn" @click="handClick(1)">{{$t('16')}}</div>
      </div>
      <spinner class="spinner-component" :show="loading"></spinner>
    </div>
    <div class="delete-popup" v-if="popup" @click="disabled ? '': popup = false">
      <div class="popup" @click.stop>
        <div class="popup-title">{{$t('18')}}</div>
        <div class="popup-msg">{{$t('19')}}</div>
        <div class="popup-btn" :class="{'disabled': disabled}" @click="disabled ? '': popup = false">{{$t('21')}}</div>
        <div class="popup-btn-text" :class="{'disabled': disabled}" @click="handCancellation">{{$t('20')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { formatTime } from 'src/lib/filters';
import Spinner from 'src/components/Spinner.vue';
import locales from './lang';
export default {
  locales,
  components: {
    Spinner
  },
  computed: {
    ...mapState({
      user: state => state.user,
      currentLang: state => state.currentLang
    }),
    isUserData() {
      if (this.user.nickname) this.getExpiredTime();
      return this.user.nickname;
    },
    isDueTo() {
      if (this.user.value_of_expire_in > 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  data() {
    return {
      /**
       * 1、 正常状态
       * 2、 填写密码
       * 3、 申请中
       * 4、 申请被拒
       */
      step: 1,
      name: '',
      date: '',
      pwd: '',
      disabled: false,
      status: 'none',
      loading: false,
      popup: false
    };
  },
  mounted() {
    if (this.$route.query.token) window.localStorage.setItem('token', this.$route.query.token);
    if (this.$route.query.device_id) window.localStorage.setItem('deviceId', this.$route.query.device_id);
    this.$store.dispatch('getUserInformation');
    this.fetchStatus();
  },
  methods: {
    fetchStatus() {
      this.$http
        .get('api/get-deregister-status')
        .then(response => {
          this.status = response.data.data.status;
          if (this.status === 1) {
            this.step = 3;
          }
          if (this.status === 2) {
            this.step = 4;
          }
        })
        .catch(data => {
          this.$toast(data.data.message);
        });
    },
    getExpiredTime() {
      const user = this.user;
      var date = new Date(user.expire_at);
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var h = date.getHours() + ':';
      var m = date.getMinutes() + ':';
      var s = date.getSeconds();
      this.date = Y + M + D;
    },
    cancel(is = false) {
      if (is) {
        this.disabled = true;
        this.loading = true;
      } else {
        this.disabled = false;
        this.loading = false;
      }
    },
    handCancellation() {
      if (this.disabled) return;
      this.cancel(true);
      this.$http
        .post('api/send-deregister-application', {
          password: this.pwd
        })
        .then(msg => {
          let data = msg.data;
          if (data.code === 0) {
            this.step = 3;
            this.$toast(this.$t('24'));
            this.pwd = '';
          } else {
            this.$toast(data.message);
            if (data.code === 184) {
              this.step = 3;
              this.pwd = '';
            }
          }
          this.cancel();
          this.popup = false;
        })
        .catch(data => {
          this.cancel();
          this.$toast(data.data.message);
        });
    },
    handClick(status) {
      if (this.disabled || !this.isUserData) return;
      if (status === 2 && !this.user.has_password) {
        status = 3;
      }
      switch (status) {
        case 1:
          this.step = status;
          return;
        case 2:
          this.step = status;
          return;
        case 3:
          if (this.pwd.length === 0 && this.user.has_password) {
            this.$toast(this.$t('22'));
            return;
          } else {
            this.popup = true;
          }
          return;
        case 'cancel':
          this.cancel(true);
          this.$http
            .get('api/cancel-deregister-application')
            .then(msg => {
              let data = msg.data;
              this.cancel();
              if (data.code === 185) {
                this.step = 4;
                this.$toast(data.message);
              } else {
                this.step = 1;
                this.$toast(this.$t('26'));
              }
            })
            .catch(data => {
              this.cancel();
              this.$toast(data.data.message);
            });
          return;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.delete-account {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  background: #fff;
  padding: 30px 16px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  letter-spacing: 0;
  font-weight: 400;
  color: #333333;

  .title {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 24px;
  }
  .delete-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.delete-head {
      margin-bottom: 34px;

      .delete-name {
        display: flex;
        flex: 1;
        position: relative;
        img {
          width: 50px;
          height: 50px;
          border: 50%;
          position: relative;
        }
        .vip {
          position: absolute;
          width: 17px;
          height: 17px;
          bottom: 0;
          left: 35px;
          background-size: 17px 17px;
          &.no {
            background-image: url('~assets/images/vip_no.png');
          }
          &.yes {
            background-image: url('~assets/images/vip.png');
          }
        }
        .delete-name-text {
          padding: 0 10px;
          font-family: PingFangSC-Medium;
          font-size: 15px;
          font-weight: 500;
          word-break: break-all;
          display: flex;
          align-items: center;
          max-width: 220px;
          @media screen and(max-width: 320px) {
            max-width: 174px;
          }
        }
      }
      .delete-date-text {
        padding: 6px 11px;
        min-width: 64px;
        border-radius: 2px;
        line-height: 1;

        &.no {
          background-image: linear-gradient(145deg, #f3f3f3 0%, #bfbec2 100%, #bfbec2 100%);
          color: #666666;
        }
        &.yes {
          background-image: linear-gradient(180deg, #416cf8 3%, #ec55ff 100%);
          color: #fff;
        }
      }
    }
    &.delete-date {
      font-size: 12px;
      color: #999999;
      margin-top: 8px;
    }
  }
  .delete-btn {
    margin-top: 40px;
    height: 46px;
    background: #177fe9;
    border-radius: 4px;
    font-family: PingFangSC-Medium;
    font-size: 15px;
    color: #ffffff;
    letter-spacing: 1px;
    text-align: center;
    font-weight: 500;
    line-height: 46px;
    transition: all 0.1s;
    &.disabled {
      background: linear-gradient(145deg, #f3f3f3 0%, #bfbec2 100%, #bfbec2 100%);
    }
  }
  .delete-input {
    width: 100%;
    height: 64px;
    border: none;
    border-bottom: solid 1px #e7e7e7;
    outline: none;
  }
  .delete-status {
    font-family: PingFangSC-Medium;
    font-size: 28px;
    color: #333333;
    letter-spacing: 1px;
    line-height: 28px;
    font-weight: 500;
    margin-bottom: 24px;
  }
  .delete-status-msg {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    line-height: 20px;
    font-weight: 400;
  }
  .delete-popup {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    .popup {
      position: absolute;
      width: 295px;
      background: #ffffff;
      border-radius: 10px;
      left: calc(50% - 295px / 2);
      top: calc(50% - 295px / 2);
      text-align: center;
      .popup-title {
        font-size: 20px;
        padding-top: 30px;
        padding-bottom: 20px;
      }
      .popup-msg {
        font-size: 14px;
        color: #999999;
        padding: 0 20px;
        margin-bottom: 35px;
      }
      .popup-btn {
        width: 168px;
        height: 40px;
        background: #416cf8;
        border-radius: 100px;
        line-height: 40px;
        margin: auto;
        color: #fff;
        font-size: 18px;
        margin-bottom: 15px;
        &.disabled {
          background-image: linear-gradient(145deg, #f3f3f3 0%, #bfbec2 100%, #bfbec2 100%);
          color: #666666;
        }
      }
      .popup-btn-text {
        width: 168px;
        height: 40px;
        line-height: 40px;
        margin: auto;
        color: #0076ff;
        font-size: 18px;
        margin-bottom: 20px;
        &.disabled {
          color: #666666;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// index.vue?41e6c5e9